import React from 'react';
import {Accordion} from '../../Accordion/Accordion';
import {ContentWrapper} from './FileMetaDataTabImage.style';
import {t} from 'i18next';
import {generateIdentifier} from '../../../utils/IdentityUtils';
import EventEmitter from 'events';
import {UploadImageComponent} from '../../UploadImageComponent/UploadImageComponent';
import {FileMetaDataDialog_changeImage} from '../../../init/events';
import {TemplatePropertySettings} from '../../../models/TemplatePropertySettings';
import {isMandatoryComponent, isVisibleComponent} from '../../../utils/TemplateUtils';
import {
    STORAGE_OBJECT_OBJECT_METADATA,
    STORAGE_OBJECT_OBJECT_METADATA_THUMBNAIL_URL
} from '../../../init/storage_object_constants';
import {validateThumbnailImage} from '../../../utils';
import {Valid} from '../../validation/Valid';

export interface FileMetaDataTabImageProps {
    readonly templatePropertySettings: Map<string, TemplatePropertySettings>;
    readonly thumbnailFile: File | null;
    readonly eventEmitter: EventEmitter;
}

/**
 * @name FileMetaDataTabImage
 * @description
 * The dialog to add the metadata of a newly created file or edited file - Metadata Tabs
 */
export const FileMetaDataTabImage: React.VFC<FileMetaDataTabImageProps> = (props) => {
    const handleImage = (imageFile: File | null) => {
        props.eventEmitter.emit(FileMetaDataDialog_changeImage, imageFile);
    };

    return (
        <ContentWrapper id={generateIdentifier()}>
            {(isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA, props.templatePropertySettings)
                    && isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_THUMBNAIL_URL, props.templatePropertySettings)) &&
                <Accordion accordionHeadline={t('UPLOAD_FILE_META_DATA_DIALOG_ACCORDION_TITLE_IMAGE')}
                           startOpen>
                    <Valid
                        isValid={(isMandatoryComponent(STORAGE_OBJECT_OBJECT_METADATA_THUMBNAIL_URL, props.templatePropertySettings) ? validateThumbnailImage(props.thumbnailFile) : true)}
                        message={t('ERROR_THUMBNAIL_URL_MISSING')}>
                        <UploadImageComponent existingImage={props.thumbnailFile}
                                              onChange={handleImage}/>
                    </Valid>
                </Accordion>
            }
        </ContentWrapper>
    );
}